export const MAP_SETTINGS_FILE_ATTACHMENTS_ADD = 'MAP_SETTINGS_FILE_ATTACHMENTS_ADD';
export const MAP_SETTINGS_FILE_ATTACHMENTS_REMOVE = 'MAP_SETTINGS_FILE_ATTACHMENTS_REMOVE';
